import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const categories = [
  { icon: 'Building', label: 'Flats & Apartments', count: 'Browse', path: '/advanced-search-discovery?type=Flat' },
  { icon: 'Home', label: 'Houses & Villas', count: 'Browse', path: '/advanced-search-discovery?type=House' },
  { icon: 'Bed', label: 'PG & Hostels', count: 'Browse', path: '/advanced-search-discovery?type=PG' },
  { icon: 'Building2', label: 'Hotels & Stays', count: 'Book by night', path: '/advanced-search-discovery?type=Hotel' },
  { icon: 'Briefcase', label: 'Office Spaces', count: 'Browse', path: '/advanced-search-discovery?type=Office' },
  { icon: 'Store', label: 'Shops & Showrooms', count: 'Browse', path: '/advanced-search-discovery?type=Shop' },
  { icon: 'Warehouse', label: 'Warehouse & Godown', count: 'Browse', path: '/advanced-search-discovery?type=Warehouse' },
];

const InteractiveMapPreview = () => {
  return (
    <section className="py-10 sm:py-14 bg-white">
      <div className="max-w-[1310px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Browse by Property Type</h2>
          <p className="text-gray-500 max-w-lg mx-auto">Whether you need a room, a flat, or a commercial space</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {categories.map((c, i) => (
            <Link
              key={i}
              to={c.path}
              className="flex flex-col items-center gap-2 p-5 rounded-xl border border-gray-200 hover:border-rose-300 hover:shadow-sm transition group text-center"
            >
              <div className="w-12 h-12 rounded-xl bg-rose-50 group-hover:bg-rose-100 flex items-center justify-center transition">
                <Icon name={c.icon} size={24} className="text-rose-500" />
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-900">{c.label}</h3>
                <p className="text-xs text-gray-400 mt-0.5">{c.count}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InteractiveMapPreview;
